import React from "react";
import { default as MUITableContainer } from "@mui/material/TableContainer";
import styled from "styled-components";

const StyledMUITableContainer = styled(MUITableContainer)`
  border-radius: 16px;
  box-shadow:
    0px 3px 5px -1px rgba(60, 71, 95, 0.2),
    0px 5px 8px rgba(60, 71, 95, 0.14),
    0px 1px 14px rgba(60, 71, 95, 0.12);
`;

export const TableContainer = (props) => {
  return <StyledMUITableContainer {...props} />;
};
